// @flow

import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import { ColorSchema } from "../../global/types/scss";

const styles = theme => ({
  root: {
    color: ColorSchema("primary"),
  },
});

class LoadingProgress extends Component<*> {
  constructor(props) {
    super(props);
  }

  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <CircularProgress color="primary" classes={{ colorPrimary: classes.root }} size={this.props.size} style={this.props.style} />
    );
  }
};

export default withStyles(styles)(LoadingProgress);



// WEBPACK FOOTER //
// ./src/global/components/LoadingProgress.js